module.exports = __webpack_public_path__ + "img/JobOpportunities.869c7479.svg";